import { render, staticRenderFns } from "./AnimatedButton.vue?vue&type=template&id=ba196dd8&scoped=true"
import script from "./AnimatedButton.vue?vue&type=script&lang=js"
export * from "./AnimatedButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba196dd8",
  null
  
)

export default component.exports